import { App } from 'vue'
import Select from './LpSelect.vue'
import BaseSelect from './LpBaseSelect.vue'

const selects = {
  Select,
  BaseSelect,
}

for (const elem in selects) {
  if (selects.hasOwnProperty(elem)) {
    // @ts-ignore
    const element = selects[elem]
    element.install = (Vue: App) => {
      Vue.component(element.name, element)
    }
  }
}

export default selects
